import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import CreateGameConnector from './CreateGameConnector';

const CreateGameRoot = ({store}) => (
    <Provider store={store}>
        <CreateGameConnector />
    </Provider>
);

CreateGameRoot.propTypes = {
    store: PropTypes.shape({
        subscribe: PropTypes.func,
        dispatch: PropTypes.func,
        getState: PropTypes.func,
    }),
};

export default CreateGameRoot;



// WEBPACK FOOTER //
// ./src/apps/create_game/components/CreateGameRoot.js